module.exports = __webpack_public_path__ + "images/like-review.2f0ca65e.png";